module.exports = __webpack_public_path__ + "img/pci.4ab91935.svg";